module.exports = __webpack_public_path__ + "static/media/button-green-focussed.510224bc.png";